import script from "./hotel_availability.vue?vue&type=script&lang=js"
export * from "./hotel_availability.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__